import { Component, OnInit } from '@angular/core';
import { MobileService } from '../_services/mobile.service';
import { countries } from 'countries-list';
import { User } from '../../interfaces/user';
import { AccountService } from '../account.service';
import { FirebaseService } from 'app/services/firebase.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfigService } from 'app/services/app-config.service';

@Component({
  selector: 'app-mobile-log-in',
  templateUrl: './mobile-log-in.component.html',
  styleUrls: ['./mobile-log-in.component.scss', '../account.scss']
})
export class MobileLogInComponent implements OnInit {
  existingCred;

  user = new User();
  // user: User = {
  //   username: '',
  //   password: '',
  // };


  phoneCode = '';
  phoneNumber = '';

  chosenCountry = {
    capital: '',
    continent: '',
    currency: '',
    emoji: '',
    emojiU: '',
    languages: [],
    name: '',
    native: '',
    phone: ''
  };


  errors = {
    phone: '',
    code: '',
    password: '',
  };

  loadingUserCountry = true;
  isSelectOpen = false;
  isLoading;
  redirectUrl;


  countryList = [];


  constructor(
    private mobileService: MobileService,
    public accountService: AccountService,
    private firebaseService: FirebaseService,
    private activatedRoute: ActivatedRoute,
    public router: Router,
    private appConfigService: AppConfigService,
  ) {
    this.countryList = Object.keys(countries).map(function (personNamedIndex) {
      const country = countries[personNamedIndex];
      return country;
    });
  }

  ngOnInit() {
    this.redirectUrl = this.activatedRoute.snapshot.queryParamMap.get('next');
    this.existingCred = this.activatedRoute.snapshot.queryParamMap.get('cred');
    this.phoneNumber = this.existingCred ? this.existingCred : '';
    const data = this.appConfigService.config.geo_info;
      this.chosenCountry = this.countryList.find(country => country.name === data['country_name']);
      this.phoneCode = '+' + this.chosenCountry.phone;
      this.loadingUserCountry = false;
  }


  toggleSelect() {
    this.isSelectOpen = !this.isSelectOpen;
  }

  handleSelect(country) {
    this.chosenCountry = country;
    this.phoneCode = `+${country.phone}`;
    this.phoneNumber = '';
    this.isSelectOpen = false;
  }

  public onSubmit() {
    this.user.username =  this.phoneCode + this.phoneNumber;
    this.isLoading = false;
    this.accountService.login(this.user, this.redirectUrl).subscribe(
      data => {
        this.firebaseService.setUserId(data.user_id);
        this.firebaseService.logEvent('login', {
          method: 'phone_number',
        });
        this.isLoading = false;
        if (this.activatedRoute.snapshot.queryParamMap.get('contrib')) {
          window.location.href = this.activatedRoute.snapshot.queryParamMap.get('contrib');
        }
      },
      errors => {
        this.errors = errors;
        this.isLoading = false;
        this.firebaseService.logEvent('login_error', {
          reason: errors.detail,
        });
      }
    );
  }
}
